import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { colors, screens } from '../common/constants';

export const StyledRoomResult = styled(Row)`
  border-right: 1px solid #ccc;

  .room-availablity {
    font-weight: 500;
  }
`;

export const StyledRoomItem = styled(Col)`
  border-left: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  padding: 8px 16px;

  .room-image {
    border-radius: 8px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
`;

export const StyledSearch = styled.div`
  background-color: #fff;
  width: 100%;

  .container {
    position: relative;
  }

  .search-container {
    .react-datepicker-wrapper {
      width: 100%;
    }
  }
`;

export const StyledOriginalPrice = styled.div`
  text-decoration: line-through;
  color: darkgray;
`;

export const StyledRoomPrice = styled.div`
  font-weight: 500;
  font-size: 1.6rem;
  text-align: right;
  margin-bottom: 4px;
`;

export const StyledRoomDescription = styled.div`
  white-space: pre-line;
`;

export const StyledNotAvailableText = styled.div`
  font-weight: 500;
  color: ${colors.primary};
`;

export const StyledSearchSection = styled.div`
  background-color: #fff;
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding-top: 4px;
  padding-bottom: 8px;
  z-index: 1000;

  .search-header {
    display: flex;
    justify-content: space-between;

    .hotel-name {
      font-size: 0.8rem;
      opacity: 0.5;
    }
  }

  .react-select__menu,
  .react-datepicker-popper {
    z-index: 1000;
  }

  .search-container {
    display: grid;
    grid-template-columns: 1fr 1fr 100px;
    gap: 0 8px;

    .action-buttons {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }

    @media (max-width: ${screens.sm}) {
      gap: 8px;
      grid-template-columns: 1fr 1fr;
    }
  }
`;

export const StyledHotelName = styled.div`
  color: ${colors.primary};
  font-weight: 500;
`;
